import { onScopeDispose, ref, watch } from 'vue';

// every tick re-renders the whole answer, so it advances on a timer rather than every frame;
// the backlog shrinks by a share per tick, which spreads a burst over about 200ms
const TICK_MS = 50;
const CATCH_UP_TICKS = 4;

const isHighSurrogate = (code) => code >= 0xd800 && code <= 0xdbff;

export default function useAiChatPacedText(target) {
  const shown = ref(null);
  let tick = null;

  const cancel = () => {
    if (tick !== null) {
      clearTimeout(tick);
      tick = null;
    }
  };

  const shownLength = () => shown.value?.length ?? 0;

  const advance = () => {
    tick = null;
    const text = target.value;
    const backlog = text.length - shownLength();
    let end = shownLength() + Math.max(1, Math.ceil(backlog / CATCH_UP_TICKS));
    if (end < text.length && isHighSurrogate(text.charCodeAt(end - 1))) {
      end += 1;
    }
    shown.value = text.slice(0, end);
    if (end < text.length) {
      tick = setTimeout(advance, TICK_MS);
    }
  };

  watch(target, (text) => {
    if (text === null) {
      cancel();
      shown.value = null;
      return;
    }
    if (shown.value !== null && !text.startsWith(shown.value)) {
      shown.value = null;
    }
    if (shown.value === null) {
      cancel();
      advance();
      return;
    }
    if (tick === null && shownLength() < text.length) {
      tick = setTimeout(advance, TICK_MS);
    }
  }, { immediate: true });

  onScopeDispose(cancel);

  return shown;
}
